<template lang="pug">
    section#destaque
        div.wrapper
            div.destaque
                router-link(:to="{name:'noticia', params: {slug: destaque.slug}}")
                    div.img
                        img(:src="destaque.thumb_link", alt="")
                    div.conteudo
                        h3 {{destaque.titulo}}
                        time(datetime='destaque.date') {{destaque.date}}
                        p {{destaque.resumo}}
                    span [+] Leia mais.
</template>

<script>
export default {
    name: "section-destaque",
    props: {
        destaque: Object
    }
}
</script>

<style lang="stylus" scoped src="./Destaque.styl"></style>
